import { useContext, useCallback } from 'react';
import _isNil from 'lodash/isNil';

import { AjaxContext, AppContext, UserContext } from 'commons-ui';

import { UserDetailsContext } from 'context/userDetails';
import { PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import { ADMIN_ACTION_TYPES } from './components/utils/constants';

type useServiceT = {
	ltid: number | null;
	mttid: number | null;
	cgrid: number | null;
};

type RefundPropsT = {
	reason: string;
	attachments: string[];
	adminActionType: ADMIN_ACTION_TYPES;
	freshdeskTicketId: string;
};

const useService = (props: useServiceT) => {
	const {
		app: { appName }
	} = useContext(AppContext);
	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);
	const { postData } = useContext(AjaxContext);
	const { user } = useContext(UserContext);

	const { ltid, mttid, cgrid } = props;

	const refundTournament = useCallback(async (refundProps: RefundPropsT) => {
		const { reason, attachments, adminActionType, freshdeskTicketId } = refundProps;
		const reqBody: any = {
			zupeeUserId: uid,
			reason,
			attachments,
			agentName: user?.userName,
			action: adminActionType,
			actionOwner: 'CRM',
			freshdeskTicketId
		};

		if (!_isNil(mttid)) {
			reqBody.mttid = mttid;
		} else if (!_isNil(cgrid)) {
			reqBody.cgrid = cgrid;
		} else {
			reqBody.ltid = ltid;
		}

		const result = await postData({
			endpoint: `/dashboard/refundTournament/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.gameplay}-refundTournament`,
			queryParams: {
				appName
			},
			body: reqBody
		});

		return result;
	}, []);

	return {
		refundTournament
	};
};

export default useService;
